import "./styles.scss"

import React from "react"
import { motion } from "framer-motion"

import { fadeAnimation } from "utils"

const Content = ({ data }) => {
  return (
    <section className="careers-content">
      <div className="container">
        <div className="row careers-content__row flex-column-reverse flex-md-row">
          <div className="col-md-6">
            <motion.div {...fadeAnimation}>
              <h2>{data?.careersContentDescription.heading}</h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: data?.careersContentDescription.text,
                }}
              />
            </motion.div>
          </div>
          <div className="col-xl-5 col-md-6 offset-xl-1">
            <motion.img
              src={data?.careersContentThumbnail?.sourceUrl}
              alt=""
              {...fadeAnimation}
            />
          </div>
        </div>

        <div className="careers-content__icons">
          <motion.h2 {...fadeAnimation}>
            {data?.careersBenefitsHeading}
          </motion.h2>
          <div className="row">
            {data?.careersBenefitsItems?.map((item, index) => (
              <div className="col-md-6 col-lg-3" key={index}>
                <motion.div
                  className="careers-content__icons-item"
                  {...fadeAnimation}
                >
                  <img src={item.icon?.sourceUrl} alt="" />
                  <p>{item.text}</p>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Content
